import { FormattedMessage } from 'react-intl';
import { IconBrandChrome, IconHelp, IconSitemap, IconUserCircle, IconCertificate, IconFlag } from '@tabler/icons';
import { NavItemType } from 'types';

const other = (role_id: number): NavItemType => {
    const items = [
        {
            id: 'certificates',
            title: <FormattedMessage id="certificates" />,
            type: 'item',
            url: '/certificates',
            icon: IconCertificate,
            breadcrumbs: false
        }
    ];

    if (role_id === 1 || role_id === 3) {
        items.push({
            id: 'users',
            title: <FormattedMessage id="Users" />,
            type: 'item',
            url: '/users',
            icon: IconUserCircle,
            breadcrumbs: false
        });
    }

    if (role_id === 1) {
        items.push({
            id: 'blocked-countries',
            title: <FormattedMessage id="Blocked Countries" />,
            type: 'item',
            url: '/blocked-countries',
            icon: IconFlag,
            breadcrumbs: false
        });
        items.push({
            id: 'country-rules',
            title: <FormattedMessage id="Country Rules" />,
            type: 'item',
            url: '/country-rules',
            icon: IconFlag,
            breadcrumbs: false
        });
    }

    return {
        id: 'sample-docs-roadmap',
        icon: IconCertificate,
        type: 'group',
        children: items
    };
};

export default other;
